import { http } from '../../core/services';

const loadCommunity = (communityId, isInPreviewMode) =>
  http.get(`/api/providers/${communityId}${isInPreviewMode ? '/preview' : ''}`).then(response => response.data);

export default loadCommunity;
